<template>
	<div class="flex items-start">
		<div class="h-5 flex items-center">
			<input
				:id="id"
				v-model="inputValue"
				:name="name"
				type="checkbox"
				class="h-4 w-4 text-secondary border-gray-300 rounded focus:outline-none focus:ring-0"
			/>
		</div>
		<div class="ml-3 text-sm">
			<label v-if="label" for="comments" class="font-medium text-gray-700">
				{{ label }}
			</label>
			<p v-if="html" class="text-sm" v-html="html"></p>
			<p v-if="description" class="text-gray-700 text-sm">{{ description }}</p>
			<p v-if="errorMessage" class="text-red-500 text-xs font-normal mt-3">
				{{ errorMessage }}
			</p>
		</div>
	</div>
</template>

<script>
import { useModelWrapper } from '@/utils/modelWrapper'

export default {
	props: {
		label: {
			type: String,
			required: true,
		},
		id: {
			type: String,
			required: false,
			default: '',
		},
		name: {
			type: String,
			required: false,
			default: '',
		},
		description: {
			type: String,
			required: false,
			default: '',
		},
		modelValue: {
			type: [String, Number, Boolean],
			default: null,
		},
		errorMessage: {
			type: String,
			required: false,
			default: '',
		},
		required: {
			type: Boolean,
			required: false,
			default: false,
		},
		html: {
			type: String,
			required: false,
			default: '',
		},
	},
	setup(props, { emit }) {
		return {
			inputValue: useModelWrapper(props, emit, 'modelValue'),
		}
	},
}
</script>

<style lang="scss" scoped></style>
